// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Z9ObA","title":"AfterFrontImage_title___zpOt"};